import React from 'react';

export interface ErrorBoundaryProps {
    onError?: (error: Error, info: React.ErrorInfo) => void;
    errorSlot: React.ReactElement<unknown, string | React.FunctionComponent | typeof React.Component>;
}

interface ErrorBoundaryState {
    hasError?: boolean;
}

export class ErrorBoundary extends React.Component<React.PropsWithChildren<ErrorBoundaryProps>, ErrorBoundaryState> {
    constructor(props: ErrorBoundaryProps) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    componentDidCatch(error: Error, info: React.ErrorInfo) {
        this.setState({ hasError: true });

        this.props.onError?.(error, info);
    }

    render() {
        if (this.state.hasError) {
            return this.props.errorSlot;
        }

        return <>{this.props.children}</>;
    }
}
